/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_InsightsInputs */

const en_nav_insights = /** @type {(inputs: Nav_InsightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insights`)
};

/**
* | output |
* | --- |
* | "Insights" |
*
* @param {Nav_InsightsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_insights = /** @type {((inputs?: Nav_InsightsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_InsightsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_insights(inputs)
});